import { useState, useContext, useEffect } from "react";
import DataTable from "core/ui/data-table";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Alert } from 'reactstrap';
import FormatDateTime from "core/utils/FormatDateTime";
import SessionContext from "SessionContext";
import { withRouter, Link } from "react-router-dom";
import ConfirmSuccess from "../core/ui/confirm-success";
import { formatPopulationDomain } from "./explorer";

const Models = (props) => {
  const context = useContext(SessionContext);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [deleteModelInfo, setDeleteModelInfo] = useState({});
  const [showSuccess, setShowSuccess] = useState(false);
  const [tableKey, setTableKey] = useState(false);
  const [chartsLoaded, setChartsLoaded] = useState(context.chartsStore.loaded);
  const [pendingOrderNavigation, setPendingOrderNavigation] = useState(null);
  const [pendingOrderNavigationUrl, setPendingOrderNavigationUrl] = useState("");

  const table_columns = [
    { header: "Model Name", key: "name" },
    {
      header: "Create Date",
      key: "create_date",
      render: (value) => <FormatDateTime date={value.created_date} />,
    },
    { header: "Created By", key: "created_by" },
    { header: 'Status', key: 'status', render: (value) => onClickModelStatus(value) },
    {header: 'Population Domain', key: 'population_domain', render: (value) => formatPopulationDomain(value.population_domain) }
  ];

  useEffect(() => {
    if (chartsLoaded !== context.chartsStore.loaded) {
      setChartsLoaded(context.chartsStore.loaded);
    }

    if (chartsLoaded && pendingOrderNavigation) {
      props.history.push(`${pendingOrderNavigationUrl}${pendingOrderNavigation.id}`);
      setPendingOrderNavigation(null);
      setPendingOrderNavigationUrl("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[chartsLoaded, pendingOrderNavigation, context.chartsStore.loaded]);

  function onClickModelStatus(value) {
    const modelState = { id: value.id };
    return (
      <ul className="action-menu">
      <Button color="link" size="sm">
        <i className="bi bi-info-circle" />{" "}
        <Link to={{pathname:"/model-status", state: modelState}}>
          {value.status}
        </Link>
      </Button>
      </ul>
    );
  }

  function checkIfPopulationMatches(model, url) {
    context.crossfilterStore.restoreFromAudience("clear_all");
    if (model.population_domain !== context.crossfilterStore.explorerModule) {
      context.crossfilterStore.setExplorerModule(model.population_domain);
    }

    if (chartsLoaded) {
      // Already loaded — navigate immediately
      props.history.push(`${url}${model.id}`);
    } else {
      // Not yet loaded — store the order and wait
      setPendingOrderNavigation(model);
      setPendingOrderNavigationUrl(url);
    }
  }

  function onClickModelDetails(_model) {
    if (_model.status === "Created") {
      checkIfPopulationMatches(_model, "/model#model=")
    } else {
      checkIfPopulationMatches(_model, "/model-details#model=")
    }
  }

  function onAskDeleteModel(model) {
    setDeleteId(model.id);
    setDeleteModelInfo({ name: model.name, description: model.description });
    toggleDeleteModal();
  }

  function toggleDeleteModal() {
    setConfirmDelete(v => !v);
  }

  function onCancelDelete() {
    setDeleteId(null);
    setDeleteModelInfo({});
    toggleDeleteModal();
  }

  function onFinalDeleteModel() {
    context.command(`model/delete?id=${deleteId}`)
      .then(() => {
        toggleDeleteModal();
        setShowSuccess(true);
        setDeleteId(null);
        setDeleteModelInfo({});
        setTimeout(() => {
          setShowSuccess(false);
          setTableKey(v => !v);
        }, 2000);
      })
      .catch((err) => {
        console.log("Delete Failed", JSON.stringify(err));
      })
  }

  const access = context.appState.userCan;
  const table_actions = (model) => (
    <ModelActions
      model={model}
      onModelDetails={onClickModelDetails}
      onDeleteModel={onAskDeleteModel}
      access={access}
    />
  );
  return (<>
    <div className="page models-page" key={tableKey}>
      <div className="sticky-page-header">
        <h1>Models</h1>
      </div>
        <DataTable
          query="model/list"
          cols={table_columns}
          actions={table_actions}
          empty="No Models Found"
        />
    </div>
    <Modal centered backdrop
      isOpen={confirmDelete}
    >
      <ModalHeader>
        Delete Model
      </ModalHeader>
      <ModalBody>
        <Alert color="light" className="d-flex">
          <i className="bi bi-exclamation-octagon"></i>
          <div>
          Selecting <b>delete</b> will permanently remove all instances from AudienceMaker and cannot be undone. Are you sure you want to continue?
          </div>
        </Alert>
        <Alert color="light" className="">
          <p>
            <span className="header-modal-text">Model Name</span>
            <span className="d-block ms-3">{deleteModelInfo.name}</span>
          </p>
          <p>
            <span className="header-modal-text">Description</span>
            <span className="d-block ms-3">{deleteModelInfo.description}</span>
          </p>
        </Alert>
      </ModalBody>
      <ModalFooter>
        <Button className="promote" onClick={onCancelDelete}>Cancel</Button>
        <Button onClick={onFinalDeleteModel}>Delete</Button>
      </ModalFooter>
    </Modal>
    <ConfirmSuccess show={showSuccess} label="Model deleted successfully." />
  </>);
};
export default withRouter(Models);

const ModelActions = (props) => {
  const model = props.model;
  const onModelDetails = props.onModelDetails;
  const onDeleteModel = props.onDeleteModel;
  const access = props.access;
  let action = "";

  action =
    <ul className="action-menu">
      <li>
        <Button color="link" size="sm" onClick={(e) => onModelDetails(model)}>
          <i className="bi bi-eye" /> Model
        </Button>
      </li>
      {access('model_delete') && <>
        <li>&nbsp;</li>
        <li>
          <Button color="link" size="sm" onClick={(e) => onDeleteModel(model)}>
            <i className="bi bi-trash" /> Delete
          </Button>
        </li>
      </>}
    </ul>

  return (
    <>
    { action }
    </>
  );
};
export { ModelActions };
